import { createSlice, current } from '@reduxjs/toolkit';
import { dashboardColumnData, drillColumnData } from '../constants/RiskColmunData';
export const riskFilterSlice = createSlice({
  name: 'riskFilterSlice',
  initialState: {
    filterQueryArray: [],
    type: '',
    checkBoxData: [],
    selectedChipArray: [],
    FinalChipArray: [],
    showCard: false,
    applyEvent: false,
    searchString: '',
    cancelEvent: false,
    clearAllEvent: false,
    isLoader: false,
    initialLimit: 10,
    initialOffset: 0,
    chipArray: [],
    watchValue: 0,
    recoReqBody: {
      fieldList: null,
      filter: '',
      limit: 10,
      objectType: null,
      offset: 0,
      recommendationOrImpact: 'Recommendation',
      sortBy: 'originRiskScore:DSC'
    },
    riskReqBody: {
      filter: '',
      limit: 10,
      offset: 0,
      sortBy: 'originRiskScore:DSC'
    },
    accountRiskReqBody: {
      filter: '',
      limit: 10,
      offset: 0,
      origin: '',
      sortBy: 'originRiskScore:DSC'
    },
    dashboardColumnData: dashboardColumnData,
    drillColumnData: drillColumnData,
    isAccordionOpen: false
  },
  reducers: {
    pushComponentString: (state, action) => {
      if (state.filterQueryArray.length) {
        state.filterQueryArray = [];
      }

      state.filterQueryArray[0] = action.payload;
    },
    pushOperationString: (state, action) => {
      if (state.filterQueryArray[0].length) {
        state.filterQueryArray[1] = action.payload;
      }
    },
    pushValueString: (state, action) => {
      if (state.filterQueryArray.length >= 2) {
        state.filterQueryArray[2] = action.payload;
      }
    },
    pushSelectedType: (state, action) => {
      state.type = action.payload;
    },
    pushCheckboxData: (state, action) => {
      state.checkBoxData = action.payload;
    },
    pushChipArray: (state, action) => {
      state.chipArray = action.payload;
    },
    pushSelectedChipArray: (state, action) => {
      state.selectedChipArray = action.payload;
    },
    pushChipArrayAddCriteria: state => {
      let existingChip = [...state.FinalChipArray];
      state.selectedChipArray.forEach(chip => existingChip.push(chip));
      let newChipArray = [...new Set(existingChip)];
      state.FinalChipArray = newChipArray;
      state.queryStringArray = [];
      state.selectedChipArray = [];
    },
    deleteChip: (state, action) => {
      let currentState = current(state.FinalChipArray);
      let updatedArray = currentState.filter(chip => !chip.includes(action.payload.entityName + ' ' + action.payload.entityOpr));
      state.FinalChipArray = updatedArray;
    },
    deleteChipArrayAddCriteria: (state, action) => {
      state.FinalChipArray = action.payload;
    },
    pushShowCard: (state, action) => {
      state.showCard = action.payload;
    },
    pushApplyEvent: (state, action) => {
      state.applyEvent = action.payload;
    },
    pushCancelEvent: (state, action) => {
      state.cancelEvent = action.payload;
    },
    pushClearAllEvent: (state, action) => {
      state.clearAllEvent = action.payload;
    },
    pushClearFilterArray: (state, action) => {
      state.filterQueryArray = action.payload;
    },
    setSearchString: (state, action) => {
      state.searchString = action.payload;
    },
    pushRiskInitialLimit: (state, action) => {
      state.riskReqBody.limit = action.payload;
    },
    pushRiskInitialOffset: (state, action) => {
      state.riskReqBody.offset = action.payload;
    },
    pushRiskInitialSortBy: (state, action) => {
      state.riskReqBody.sortBy = action.payload;
    },
    pushAccountRiskInitialLimit: (state, action) => {
      state.accountRiskReqBody.limit = action.payload;
    },
    pushAccountRiskInitialOffset: (state, action) => {
      state.accountRiskReqBody.offset = action.payload;
    },
    pushAccountRiskInitialSortBy: (state, action) => {
      state.accountRiskReqBody.sortBy = action.payload;
    },
    pushAccountRiskBody: (state, action) => {
      state.accountRiskReqBody = action.payload;
    },
    pushInitialLimit: (state, action) => {
      state.recoReqBody.limit = action.payload;
    },
    pushInitialOffset: (state, action) => {
      state.recoReqBody.offset = action.payload;
    },
    pushRecoSortBy: (state, action) => {
      state.recoReqBody.sortBy = action.payload;
    },
    pushRecoReqBody: (state, action) => {
      state.recoReqBody = action.payload;
    },
    pushRiskBody: (state, action) => {
      state.riskReqBody = action.payload;
    },
    pushRecoFilterWatch: (state, action) => {
      state.watchValue = action.payload;
      let watchStatusValue = 'underWatch' + '=' + action.payload;

      if (!action.payload) {
        let filterString = state.recoReqBody.filter.replace('underWatch=1,', '');
        state.recoReqBody.filter = filterString.toString();
      } else {
        if (action.payload === 1) state.recoReqBody.filter = state.recoReqBody.filter + ',' + watchStatusValue;
      }
    },
    pushRiskDashboardColumns: (state, action) => {
      state.dashboardColumnData = action.payload;
    },
    pushRiskDrillColumns: (state, action) => {
      state.drillColumnData = action.payload;
    },
    setAccordionOpen: (state, action) => {
      state.isAccordionOpen = action.payload;
    },
    pushSearchChipArray: (state, action) => {
      state.searchChipArray = action.payload;
    },
    showLoader: (state, action) => {
      state.isLoader = action.payload;
    },

    /* eslint-disable no-unused-vars */
    toggleUnmount: state => {}
  }
});
export const {
  pushRecoReqBody,
  pushRiskBody,
  pushComponentString,
  pushOperationString,
  pushValueString,
  pushSelectedType,
  pushCheckboxData,
  pushSelectedChipArray,
  pushChipArrayAddCriteria,
  deleteChip,
  deleteChipArrayAddCriteria,
  pushShowCard,
  pushApplyEvent,
  pushScoreValue,
  pushClearFilterArray,
  setSearchString,
  pushCancelEvent,
  pushClearAllEvent,
  pushInitialLimit,
  pushInitialOffset,
  pushRiskInitialLimit,
  pushRiskInitialOffset,
  pushRecoSortBy,
  pushRecoFilterWatch,
  pushAccountRiskBody,
  pushAccountRiskInitialLimit,
  pushAccountRiskInitialOffset,
  pushRiskInitialSortBy,
  pushAccountRiskInitialSortBy,
  pushChipArray,
  pushRiskDashboardUpdatedColumns,
  pushRiskDashboardColumns,
  pushRiskDrillColumns,
  setAccordionOpen,
  pushSearchChipArray,
  showLoader,
  toggleUnmount
} = riskFilterSlice.actions;
export default riskFilterSlice.reducer;